import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { RFQIsSalesOnlyPropertyState } from "@theHescoBlueprint/Handlers/RFQIsSalesOnlyPropertyState";
import { Draft } from "immer";

const initialCuttingToolConfigState: RFQIsSalesOnlyPropertyState = {
    isSalesOnly: false,
};

const isSalesOnly = createTypedReducerWithImmer(initialCuttingToolConfigState, {
    "Custom/RFQIsSalesOnly/IsSalesOnlyProperty": (
        draft: Draft<RFQIsSalesOnlyPropertyState>,
        action: { result: RFQIsSalesOnlyPropertyState },
    ) => {
        draft.isSalesOnly = !draft.isSalesOnly;
    },
});
(reducers as any).isSalesOnly = isSalesOnly;

export type CustomState = {
    isSalesProperty: RFQIsSalesOnlyPropertyState;
} & ApplicationState;

type Reducers = {
    isSalesOnly: typeof isSalesOnly;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
